/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

// TODO: This function is specific to gclid as of now, if required later can be changed to support multiple id's like fbclid etc...

const getClickIds = () => {
  const extractGclidFromUrl = (url) => {
    try {
      const parsedUrl = new URL(url);
      const params = new URLSearchParams(parsedUrl.search);
      const gclid = params.get("gclid");

      if (!gclid) {
        return null;
      }

      return gclid;
    } catch (error) {
      console.error("Invalid URL provided:", error.message);
      return null;
    }
  };

  return {
    extractGclidFromUrl
  };
};

export default getClickIds;

